import React from "react"

import classNames from "classnames"
import { Portlet } from "./"
import { makeStyles, Typography, Divider, Box } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
  root: {},
  header: {
    padding: theme.spacing(4),
  },
  footer: {
    padding: theme.spacing(4),
  },
  feature: {
    fontWeight: theme.typography.fontWeightMedium,
    marginBottom: theme.spacing(1),
    fontSize: "14px",
    lineHeight: "18px",
    textTransform: "capitalize",
  },
  status: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
    textTransform: "capitalize",
    borderRadius: 2,
    lineHeight: "40px",
  },
  statusPlanned: {
    backgroundColor: theme.palette.grey[500],
    color: theme.palette.common.white,
  },
  statusDeveloping: {
    backgroundColor: theme.palette.grey[500],
    color: theme.palette.common.white,
  },
  statusBeta: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.white,
  },
  statusCompleted: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
  },
}))

const Integration = ({ name, status, features, image }) => {
  const classes = useStyles()

  return (
    <Portlet className={classes.root}>
      <Box className={classes.header} height={140}>
          <img src={image} alt={`${name} logo`} width="100%" height="100%"/>
      </Box>
      <Divider />
      <Box className={classes.footer}>
        <Box
          display="inline-flex"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <Typography variant="h2">{name}</Typography>
          <span
            className={classNames(classes.status, {
              [classes.statusBeta]: status === "beta",
              [classes.statusDeveloping]: status === "developing",
              [classes.statusCompleted]: status === "completed",
              [classes.statusPlanned]: status === "planned",
            })}
          >
            {status}
          </span>
        </Box>
        <br />
        {features.length > 0 && (
          <>
            <Typography variant="caption">Features</Typography>
            <ul style={{ listStyle: "none", paddingLeft: 0 }}>
              {features.map(feature => (
                <li key={feature} className={classes.feature}>
                  {feature}
                </li>
              ))}
            </ul>
          </>
        )}
      </Box>
    </Portlet>
  )
}

export default Integration
